import FeeStructurePage from "../components/pages/FeeStructure";

export default FeeStructurePage;
